import { DEFAULT_THEME_PROPERTIES_BY_ORGANIZATION } from 'lib/constants/themes';
import { Organization } from 'lib/types/company';

export const getThemePropertiesForOrganization = (
  organization: Organization
) => {
  const defaultProperties =
    DEFAULT_THEME_PROPERTIES_BY_ORGANIZATION[organization] ??
    DEFAULT_THEME_PROPERTIES_BY_ORGANIZATION[Organization.ETHENA];
  return defaultProperties;
};
